import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/**
 * Custom element to display nutrition info table image that updates on variant change.
 */
export default class GoodnessNutritionImage extends Component {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const newImageContainer = html.querySelector(`goodness-nutrition-image[data-section-id="${this.dataset.sectionId}"]`) 
          || html.querySelector('goodness-nutrition-image');

        if (newImageContainer) {
          this.innerHTML = newImageContainer.innerHTML;
        }
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[goodness-nutrition-image] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('goodness-nutrition-image')) {
  customElements.define('goodness-nutrition-image', GoodnessNutritionImage);
}
